<!-- Interactive Areas -->
@for (group of slideAuthorFacade.currentSelectedSlideImageAreaGroups$ | async; track (group.id || $index)) {
  <medsurf-design-content-panel [titleText]="group.name"
    (click)="handleClick(group)"
    [collapsed]="true"
    class="cursor-pointer"
    [toggleable]="true">
    <div class="p-2 bg-primary-100">
      <span [innerHtml]="group.description"></span>
    </div>
  </medsurf-design-content-panel>
}
